import { useTranslation } from 'react-i18next';

import { DorfHelferTypeEnum } from '@/features/posts/types/dorfHelferType';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

export const useGetDorfHelferTypeName = (
  dorfHelferType?: DorfHelferTypeEnum
) => {
  const { t } = useTranslation(LocalizationNameSpace.POSTS, {
    keyPrefix: 'dorfHelferTypes'
  });
  switch (dorfHelferType) {
    case DorfHelferTypeEnum.OFFER: {
      return t(DorfHelferTypeEnum.OFFER);
    }
    case DorfHelferTypeEnum.REQUEST: {
      return t(DorfHelferTypeEnum.REQUEST);
    }
  }
};
